import type { MouseEvent } from 'react'
import { IconHeart, IconHeartFilled } from './AppNavIcons'

type Props = {
  active: boolean
  label: string
  className?: string
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
}

export default function ListingFavoriteButton({ active, label, className, onClick }: Props) {
  return (
    <button
      type="button"
      className={`listing-fav-btn${active ? ' listing-fav-btn--on' : ''}${className ? ` ${className}` : ''}`}
      aria-label={label}
      aria-pressed={active}
      onClick={onClick}
    >
      {active ? (
        <IconHeartFilled width={18} height={18} />
      ) : (
        <IconHeart width={18} height={18} />
      )}
    </button>
  )
}
